<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="APP-URL" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-upload v-decorator="['appUrl',validatorRules.appUrl]"></j-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="版本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['appVersion',validatorRules.appVersion]" placeholder="请输入版本号"
                              style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="更新时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择更新时间" v-decorator="['uploadTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['remark']" placeholder="请输入备注"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('remark')" :popLists="getMainTablePop('remark')">
                <a-input
                  v-decorator="['remark']"
                  :read-only="whetherLang('remark')"
                  @click="isLangClick('remark', false)"
                  :placeholder="$t('label.pleaseEnterANote')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

import {httpAction, getAction} from '@/api/manage'
import pick from 'lodash.pick'
import {validateDuplicateValue} from '@/utils/util'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JUpload from '@/components/jeecg/JUpload'
import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'


export default {
  name: 'EfsAppUploadForm',
    mixins: [mtcLangModalMixin],
  components: {
    JFormContainer,
    JDate,
    JUpload,
  },
  props: {
    //流程表单data
    formData: {
      type: Object,
      default: () => {
      },
      required: false
    },
    //表单模式：true流程表单 false普通表单
    formBpm: {
      type: Boolean,
      default: false,
      required: false
    },
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      mainTable: 'efs_app_upload',
      // form: this.$form.createForm(this),
      model: {},
      appUrl: {},
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
      confirmLoading: false,
      validatorRules: {
        appUrl: {
          rules: [
            {required: true, message: '!'},
          ]
        },
        appVersion: {
          rules: [
            {required: true, message: '!'},
            {validator: (rule, value, callback) => validateDuplicateValue('efs_app_upload', 'app_version', value, this.model.id, callback)},
          ]
        }
      },
      url: {
        add: "/uploadFile/efsAppUpload/add",
        edit: "/uploadFile/efsAppUpload/edit",
        queryById: "/uploadFile/efsAppUpload/queryById"
      }
    }
  },
  computed: {
    formDisabled() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return false
        }
        return true
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.formBpm === true) {
        if (this.formData.disabled === false) {
          return true
        }
      }
      return false
    }
  },
  created() {
    //如果是流程中表单，则需要加载流程表单data
    this.showFlowData();
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'appUrl', 'appVersion', 'uploadTime', 'remark'))
      })
    },
    //渲染流程表单数据
    showFlowData() {
      if (this.formBpm === true) {
        let params = {id: this.formData.dataId};
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result);
          }
        });
      }
    },
    submitForm() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }
          let formData = Object.assign(this.model, values);
          getAction("/uploadFile/efsAppUpload/getMaxAppVersion", {}).then((maxAppVersionRes) => {
            console.log(maxAppVersionRes)
            if (formData.appVersion > maxAppVersionRes || this.model.id || maxAppVersionRes == undefined) {
              if (!formData.appUrl.toString().includes(',')) {
                if (formData.appUrl.split('.').pop() == 'apk') {
                  httpAction(httpurl, formData, method).then((res) => {
                    if (res.success) {
                      that.$message.success(res.message);
                      that.$emit('ok');
                    } else {
                      that.$message.warning(res.message);
                    }
                  }).finally(() => {
                    that.confirmLoading = false;
                  })
                } else {
                  that.$message.error("请上传APK文件！")
                  that.confirmLoading = false;
                }
              } else {
                that.$message.error("请勿重复上传！")
                that.confirmLoading = false;
              }
            } else {
              that.$message.error("该版本已存在！")
              that.confirmLoading = false;
            }
          })
        }
      })
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'appUrl', 'appVersion', 'uploadTime', 'remark'))
    },
  }
}
</script>